import { render, staticRenderFns } from "./PreferenceTaxBaseVariable.vue?vue&type=template&id=78c764b9&"
import script from "./PreferenceTaxBaseVariable.vue?vue&type=script&lang=ts&"
export * from "./PreferenceTaxBaseVariable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c764b9')) {
      api.createRecord('78c764b9', component.options)
    } else {
      api.reload('78c764b9', component.options)
    }
    module.hot.accept("./PreferenceTaxBaseVariable.vue?vue&type=template&id=78c764b9&", function () {
      api.rerender('78c764b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Preference/PreferenceTaxBaseVariable.vue"
export default component.exports